import { mapGetters } from "vuex";
import types from "../store/types";

export default {
  computed: {
    ...mapGetters([types.getters.booking]),
  },
  methods: {},
};



// WEBPACK FOOTER //
// ./src/mixins/booking.js